var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v("Exportar Cadastros " + _vm._s(_vm.cadastros.length))
      ]),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.exportarCadastros } },
        [_vm._v("Exportar")]
      ),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.exportarCadastrosOff } },
        [_vm._v("Exportar OFF")]
      ),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.salvarAllCadastros } },
        [_vm._v("Salvar Todos")]
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.cadastros,
            "element-loading-text": "Carregando..."
          }
        },
        [
          _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
          _c("el-table-column", {
            attrs: {
              prop: "cadastro.id",
              label: "Index",
              width: "auto",
              sortable: "sortable"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "tipo",
              label: "Tipo",
              width: "auto",
              sortable: "sortable"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "Acao", width: "auto" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    !scope.row.saved
                      ? _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v("Ações")]
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex",
                                      on: {
                                        click: function($event) {
                                          return _vm.debugCadastro(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("  Visualizar cadastro")]
                                  )
                                ]),
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex",
                                      on: {
                                        click: function($event) {
                                          return _vm.saveCadastro(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("  Salvar cadastro")]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62c17d12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c17d12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/Exportacao.vue
// module id = null
// module chunks = 